<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="fetch" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-excel</v-icon>
      Exportar
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="440" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl" :loading="loading" :disabled="loading">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-file-excel</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Reportes</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Facturación</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8 pb-4">
          <v-avatar color="primary lighten-5" size="80" class="mb-6">
            <v-icon color="primary" size="40">fas fa-cloud-download-alt</v-icon>
          </v-avatar>
          <div class="body-1 primary--text font-weight-bold mb-2">¡Elija su formato!</div>
          <div class="caption grey--text px-4 mb-8">Seleccione la opción de exportación que mejor se adapte a sus necesidades de gestión.</div>

          <div class="d-flex flex-column gap-3">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
              @click="getExcel(false)"
              :loading="loading && !detailLoading"
            >
              <v-icon left>fas fa-list-alt</v-icon>
              Lista de OTs (Excel)
            </v-btn>

            <v-btn 
              color="primary" 
              block 
              large 
              outlined
              height="48"
              class="font-weight-black text-none rounded-lg"
              @click="getExcel(true)"
              :loading="loading && detailLoading"
            >
              <v-icon left>fas fa-search-plus</v-icon>
              Detalle con Estimados
            </v-btn>

            <v-btn 
              v-if="defontana_enabled"
              color="info" 
              block 
              large 
              outlined
              height="48"
              class="font-weight-black text-none rounded-lg mt-2"
              @click="getExcelDefontanaWO()"
            >
              <v-icon left>fas fa-exchange-alt</v-icon>
              Exportar a Defontana
            </v-btn>
          </div>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import {excelInvoicedWorkOrders} from '@/api/reports'
import {excelWorkOrders} from '@/api/defontana'
import moment from 'moment'

export default {
  name: "ExportInvoiceWorkOrders",
  props: ['filter', 'options', 'disabled', 'search'],
  data() {
    return {
      loading: false,
      detailLoading: false,
      dataReady: false
    }
  },
  computed: {
    defontana_enabled() {
      return this.$store.getters.getCompany?.defontana_export_enabled || false
    }
  },
  methods: {
    async fetch() {
      this.dataReady = true
      this.loading = false
    },
    async getExcel(detail) {
      this.loading = true
      this.detailLoading = detail
      var created_before = ''
      var created_after = ''
      if (this.filter.created_after) created_after = moment(this.filter.created_after).utc().format('yyyy-MM-DD HH:mm')
      if (this.filter.created_before) created_before = moment(this.filter.created_before).utc().add(1439, 'minutes').format('yyyy-MM-DD HH:mm')
      
      const { sortBy, sortDesc } = this.options
      const sort = (sortBy && sortBy.length) ? sortBy[0] : 'id'
      const query = `detail=${detail}&search=${this.search || ''}&ordering=${sortDesc && sortDesc[0] ? sort : '-' + sort}&page=1&created_after=${created_after}&created_before=${created_before}&sales_note__customer__seller=${this.filter.seller || ''}&has_invoices=${this.filter.has_invoiced || ''}`
      
      await excelInvoicedWorkOrders(query)
        .then((response) => {
          const name = detail ? 'detalle_estimados' : 'lista_ots'
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(response);
          link.setAttribute('download', `export_${name}_${moment().format('DD-MM-YYYY_HHmm')}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          notifications.showSuccess('Reporte Excel generado')
        })
        .catch((error) => {
          const msg = error.code == "ECONNABORTED" ? 'Tiempo de espera excedido' : 'Error al exportar'
          notifications.showError(msg)
        })
        .finally(() => {
          this.loading = false
          this.detailLoading = false
        })
    },
    async getExcelDefontanaWO() {
      this.loading = true
      var created_before = ''
      var created_after = ''
      if (this.filter.created_after) created_after = moment(this.filter.created_after).utc().format('yyyy-MM-DD HH:mm')
      if (this.filter.created_before) created_before = moment(this.filter.created_before).utc().add(1439, 'minutes').format('yyyy-MM-DD HH:mm')
      
      const { sortBy, sortDesc } = this.options
      const sort = (sortBy && sortBy.length) ? sortBy[0] : 'id'
      const query = `search=${this.search || ''}&ordering=${sortDesc && sortDesc[0] ? sort : '-' + sort}&page=1&created_after=${created_after}&created_before=${created_before}&sales_note__customer__seller=${this.filter.seller || ''}&has_invoices=${this.filter.has_invoiced || ''}`
      
      await excelWorkOrders(query)
        .then((response) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(response);
          link.setAttribute('download', `export_defontana_${moment().format('DD-MM-YYYY_HHmm')}.zip`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          notifications.showSuccess('Exportación Defontana completada')
        })
        .catch((error) => {
          const msg = error.code == "ECONNABORTED" ? 'Tiempo de espera excedido' : 'Error al exportar a Defontana'
          notifications.showError(msg)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; font-family: 'Outfit', sans-serif !important; }
.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.h-44 { height: 44px !important; }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.8px; }
.gap-3 { gap: 12px; }
</style>